import PdfTemplate from "../singleton/pdf-template";

export default {

    getPDFFields: PdfTemplate.getPDFFields.bind(PdfTemplate),

    getEntityFields: PdfTemplate.getEntityFields.bind(PdfTemplate),

    showTemplate: PdfTemplate.showTemplate.bind(PdfTemplate),

    getAll: PdfTemplate.getAll.bind(PdfTemplate),

    get: PdfTemplate.get.bind(PdfTemplate),

    run: PdfTemplate.run.bind(PdfTemplate),

    delete: PdfTemplate.delete.bind(PdfTemplate),

    setOrder: PdfTemplate.setOrder.bind(PdfTemplate)

}